import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import api from '../services/api';

const RESOURCES = ['students', 'dosens', 'courses', 'periods', 'semesters', 'kelas', 'kelas-mahasiswa', 'kelas-mata-kuliah', 'admins', 'assessments', 'enrollments', 'teachings'];

function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 50, totalPages: 1 });
  const [resource, setResource] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadLogs = async (page = 1) => {
    setLoading(true);
    try {
      const params = { page };
      if (resource) params.resource = resource;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      const res = await api.getAuditLogs(params);
      setLogs(res.data || []);
      setPagination(res.pagination || { total: 0, page: 1, limit: 50, totalPages: 1 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadLogs(1); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="card">
      <h3 className="card-title" style={{ marginBottom: '1rem' }}>Audit Log</h3>
      <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <select className="period-input" value={resource} onChange={e => setResource(e.target.value)}>
          <option value="">Semua Resource</option>
          {RESOURCES.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
        <input type="date" className="period-input" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <input type="date" className="period-input" value={endDate} onChange={e => setEndDate(e.target.value)} />
        <button className="btn-primary" onClick={() => loadLogs(1)}>Filter</button>
      </div>
      {loading && <p>Memuat...</p>}
      {!loading && logs.length === 0 && <p>Belum ada aktivitas.</p>}
      {!loading && logs.length > 0 && (
        <div className="table-container"><table className="data-table">
          <thead>
            <tr><th>Waktu</th><th>Admin</th><th>Method</th><th>Resource</th><th>ID</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <React.Fragment key={log.id}>
                <tr onClick={() => setExpandedId(expandedId === log.id ? null : log.id)} style={{ cursor: 'pointer' }}>
                  <td>{new Date(log.created_at).toLocaleString('id-ID')}</td>
                  <td>{log.admin_name}</td>
                  <td>{log.method}</td>
                  <td>{log.resource}</td>
                  <td>{log.resource_id || '-'}</td>
                  <td><span className={`badge ${log.success ? 'badge-info' : 'badge-warning'}`}>{log.success ? 'Sukses' : 'Gagal'}</span></td>
                  <td>{expandedId === log.id ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</td>
                </tr>
                {expandedId === log.id && (
                  <tr><td colSpan={7}><pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.8rem', background: '#F5F7F6', padding: '0.75rem', borderRadius: '0.375rem' }}>{log.request_summary}</pre></td></tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table></div>
      )}
      {pagination.totalPages > 1 && (
        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem', alignItems: 'center' }}>
          <button className="btn-secondary" disabled={pagination.page === 1} onClick={() => loadLogs(pagination.page - 1)}>‹ Prev</button>
          <span>Halaman {pagination.page} / {pagination.totalPages}</span>
          <button className="btn-secondary" disabled={pagination.page === pagination.totalPages} onClick={() => loadLogs(pagination.page + 1)}>Next ›</button>
        </div>
      )}
    </div>
  );
}

export default AuditLogPage;
